import types, { ICompanyTeam } from './types'

export default {
  set: (company: ICompanyTeam) => ({ type: types.SET, payload: company }),
  delete: (team_id: string) => ({ type: types.DELETE, payload: team_id }),
}
